module.exports = __webpack_public_path__ + "static/media/books.2242a93a.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/books.jpg
 ** module id = 452
 ** module chunks = 0
 **/